// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_box":"right_box-3wreQfId","stock_box":"stock_box-TNHG9vXN"};